import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import classnames from "classnames";

import { useNotify, useRedirect, Button, Confirm } from "react-admin";

import { DeleteIcon } from "../../../../components/common/iconography";
import { logError } from "../../../../utils/appUtils";
import {
  deleteLambdaPickListItem,
  updateOutboundQuantity,
} from "./PickListItemUtils";
import { ShipmentLineItemStatus } from "../../../../utils/constants";
import { deepRedirect } from "../../../../utils/utils";

const useStyles = makeStyles(
  (theme) => ({
    deleteButton: {
      color: theme.palette.error.main,
      "&:hover": {
        backgroundColor: alpha(theme.palette.error.main, 0.12),
        // Reset on mouse devices
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
  }),
  { name: "RaDeleteWithConfirmButton" },
);

export const DeepDeleteButton = ({
  record,
  outbound,
  backPath,
  className,
  isSaving,
  isDeleting,
  setIsDeleting,
  ...props
}) => {
  const classes = useStyles();
  const notify = useNotify();
  const history = useHistory();
  const redirect = useRedirect();
  const [open, setOpen] = useState(false);

  const handleDialogOpen = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const handleRemove = async () => {
    debugger;
    setIsDeleting(true);
    try {
      const response = await deleteLambdaPickListItem(record);
      if (response.error) throw response.error;

      await updateOutboundQuantity(
        outbound,
        record,
        record.totalQuantityToPick,
        0,
      );

      notify("Pick List Item deleted successfully", "success");
      deepRedirect(history, backPath);
    } catch (error) {
      logError(
        "lineItem:DeepDeleteButton:handleRemove",
        error,
        notify,
        redirect,
      );
    } finally {
      setIsDeleting(false);
    }
  };

  const isDisabled =
    record.status === ShipmentLineItemStatus.LOADED ||
    record.status === ShipmentLineItemStatus.VERIFIED ||
    record.status === ShipmentLineItemStatus.SHIPPED;

  if (isDisabled)
    return (
      <Tooltip
        title={"Item is Loaded. Reject to enable."}
        placement="left"
        arrow
      >
        <span>
          <Button label="Delete" disabled={true}>
            <DeleteIcon />
          </Button>
        </span>
      </Tooltip>
    );

  return (
    <>
      <Button
        {...props}
        label="Delete"
        disabled={isDeleting || isSaving || isDisabled}
        onClick={handleDialogOpen}
        className={classnames(
          "ra-delete-button",
          classes.deleteButton,
          className,
        )}
      >
        <DeleteIcon />
      </Button>
      <Confirm
        isOpen={open}
        loading={isDeleting}
        title={"Delete Confirmation"}
        content={
          "Are you sure you want to delete this Outbound Pick List item?"
        }
        onConfirm={handleRemove}
        onClose={handleDialogClose}
      />
    </>
  );
};
